import { PartialBrief } from '../../../Types/Brief'
import { SupportedCurrencyCode } from '../../../Types/generated-types'

const shouldSkipRecommendations = ({ currency, budget }: PartialBrief): boolean => {
  if (currency === SupportedCurrencyCode.Usd) return true
  if (currency === SupportedCurrencyCode.Aud) return (budget ?? 0) >= 10000
  if (currency === SupportedCurrencyCode.Gbp) return (budget ?? 0) >= 5000
  return false
}

export default shouldSkipRecommendations
